module.exports = __webpack_public_path__ + "img/map-view.e3dd726b.png";